import React from "react";
import PropTypes from "prop-types";
import FormGroup from "react-bootstrap/FormGroup";

const FormContainer = ({ label, className, children, ...props }) => (
  <FormGroup
    as="fieldset"
    className={`form-container ${className || ""}`}
    {...props}
  >
    <legend className="form-container__label">{label}</legend>
    {children}
  </FormGroup>
);

FormContainer.propTypes = {
  label: PropTypes.string
};

export default FormContainer;
